import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { FormProvider } from "react-hook-form";
import { IoIosInformationCircleOutline } from "react-icons/io";
import PageLoader from "src/components/PageLoader/PageLoader";
import FormInput from "src/components/shared/Forms/FormInput/FormInput";
import { COMMON_CONSTANTS } from "src/constants/commonConstants";
import { usePassword } from "src/hooks/profile/usePassword";
import { commonLocales } from "src/locales/commonLocales";
import { locales } from "src/locales/indexLocales";
import { forgotPasswordField } from "src/utils/formData/password.data";

import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CRow,
} from "@coreui/react";

const ForgotPassword: React.FC = () => {
  const {
    forgotPasswordMethods,
    onSubmit,
    loading,
    captchaError,
    captchaVerified,
    handleCaptchaChange,
  } = usePassword();
  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <PageLoader isLoading={loading} />
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={7} lg={6} xl={5} className="p-0">
            <div className="dd-header p-0 position-relative">
              <div className="wrapLogo">
                <img
                  className="dd-logo"
                  src={COMMON_CONSTANTS.LOGIN_FORM_LOGO}
                  alt="dental dynamic staffing"
                />
              </div>
            </div>
            <CCardGroup>
              <CCard className="p-4 ">
                <CCardBody>
                  <FormProvider {...forgotPasswordMethods}>
                    <form
                      onSubmit={forgotPasswordMethods.handleSubmit(onSubmit)}
                    >
                      <h4 className="fw-bold pt-2">
                        {commonLocales.forgotPasswordHeading}
                      </h4>
                      <div className="d-flex align-items-center mt-4 mb-3">
                        <IoIosInformationCircleOutline className="dd-forgot-password-info-icon me-3" />
                        <p className="dd-forgot-password-info">
                          {commonLocales.forgotPasswordWarning}
                        </p>
                      </div>

                      <FormInput field={forgotPasswordField.username} />
                      <CRow className="mb-3">
                        <CCol className="d-flex justify-content-center">
                          <ReCAPTCHA
                            sitekey={
                              process.env.REACT_APP_RECAPTCHA_SITE_KEY as string
                            }
                            onChange={handleCaptchaChange}
                          />
                        </CCol>
                      </CRow>
                      {captchaError && (
                        <p className="text-danger text-center">
                          {commonLocales.recaptchaValidationError}
                        </p>
                      )}
                      <CRow>
                        <CCol className="d-flex justify-content-end">
                          <CButton
                            className="px-4 dd-login-button"
                            type="submit"
                            disabled={!captchaVerified}
                          >
                            {locales.getNewPassword}
                          </CButton>
                        </CCol>
                      </CRow>
                    </form>
                  </FormProvider>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default ForgotPassword;
